<template lang="pug">
Modal(ref='modal' title="Ooops, an error occurred" :closeable="true")
  form.form-group.error-box
    .row
      i.col-sm-2.text-center.red(style="font-size:26px")
        .fa.fa-exclamation-triangle
        .ml5 {{errorStatus}}
      h4.col-sm-10 {{errorHeader}}
    .error-checkbox
      label
        input(type="checkbox" v-model="showLog")
        .cb-label.ml5 {{showLog ? 'Hide' : 'Show' }} error details
    .error-message-box(v-if="showLog")
      pre.error-message {{error}}
</template>
<script>
import Modal from '@/components/common/Modal'

export default {
  data: () => ({
    errorHeader: null,
    errorStatus: null,
    error: null,
    showLog: false
  }),
  methods: {
    show(e) {
      const error = e.response || e;
      this.error = error.data || error;
      this.errorHeader = this.error.message
      this.errorStatus = this.error.status
      this.error = error
      this.$refs.modal.open()
    }
  },
  components: {
    Modal
  }
}
</script>
<style lang="scss">
.error-box {
  min-width: 50vw;
  .error-message-box {
    max-height: 500px;
    overflow: auto;
    border: solid #dedede 1px;
  }
  pre.error-message {
    white-space: pre-wrap;
    white-space: -moz-pre-wrap;
    white-space: -pre-wrap;
    white-space: -o-pre-wrap;
    word-wrap: break-word;
    border: 0;
    margin: 0;
  }
  i {
    font-size: 1vw;
  }
  .fa-exclamation-triangle {
    padding-top: 20px;
    padding-left: 0;
  }
  .error-checkbox {
    margin-top: 20px;
    label {
      font-size: 14px;
    }
    input {
      width: 20px;
      height: 20px;
    }
    .cb-label {
      margin-left: 25px;
      margin-top: -25px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/ErrorBox.vue